import { NavLink, Outlet } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { docGroups } from '../docs/manifest';

export default function Docs() {
  const groups = docGroups();

  return (
    <div className="flex h-full">
      {/* Docs sidebar */}
      <aside className="w-64 shrink-0 overflow-y-auto border-r border-slate-200 bg-white p-4">
        <div className="mb-4 flex items-center gap-2 px-2">
          <BookOpen className="h-5 w-5 text-slate-600" />
          <span className="text-sm font-semibold text-slate-900">Documentation</span>
        </div>
        <nav className="space-y-5">
          {groups.map(({ group, entries }) => (
            <div key={group}>
              <p className="mb-1 px-2 text-xs font-semibold uppercase tracking-wide text-slate-400">
                {group}
              </p>
              <div className="space-y-0.5">
                {entries.map((entry) => (
                  <NavLink
                    key={entry.slug}
                    to={entry.slug === 'index' ? '/docs' : `/docs/${entry.slug}`}
                    end={entry.slug === 'index'}
                    className={({ isActive }) =>
                      `block rounded-md px-2 py-1.5 text-sm transition-colors ${
                        isActive
                          ? 'bg-slate-100 font-medium text-slate-900'
                          : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                      }`
                    }
                  >
                    {entry.title}
                  </NavLink>
                ))}
              </div>
            </div>
          ))}
        </nav>
      </aside>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-3xl px-8 py-10">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
